import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"deck"}/>
}
